/* eslint-disable no-useless-escape */
import * as Yup from 'yup';
import moment from 'moment';
import {
  isDefine,
  filterDuplicateItem,
  hasDuplicateItem,
  trimListString,
  isNumeric,
  bytesToMegaBytes,
} from 'helpers';
import {
  MAX_DOMAIN_ALLOW_PURCHASE,
  ModesResponderEnum,
  sendMethodEnum,
  stateOffer,
  VolummType,
} from './data';
// import { smsCounter } from 'helpers/SmsCharacter';
import { checkLimitDecimal } from 'helpers/string';
import { isString, isArray, get, isInteger, isEmpty, isBoolean, has } from 'lodash';
import { messageType as messageTypeEnum } from 'consts/data';
import {
  REQUIRED_FIELD,
  INCORRECT_FORMAT,
  STRING_LENGTH_MIN,
  STRING_LENGTH_MAX,
  IS_NUMBER_TYPE,
  MUST_BE_INTEGER_NUMBER,
  MUST_BE_LARGER_THAN,
  MUST_BE_LESS_OR_EQUAL_THAN,
  MUST_BE_LARGER_OR_EQUAL_THAN,
  MUST_BE_NUMBER,
  // IS_NUMBER_TYPE,
} from './message';
import CampaignModel from 'models/campaign.model';
import { momentInstance } from 'helpers/date-time';
import ResponderModel from 'models/responder.model';
import OptOutModel from 'models/optout.model';
import RouteModel from 'models/route.model';
import cidrRegex from 'cidr-regex';

export const listDelimiter = [',', ';', '\n'];

const isPhoneNumber = /^\+[0-9]*$/;
export const onlyNumber = /^[0-9]*$/;
const maxLengthName = 20;
const validEmail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
export const phoneRegExp =
  /^[\+]((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const validDomain =
  /(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]/;
const validDomainRequireHttpHttps =
  /(?:https?\:\/\/|www\.)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]/;
const onlyLettersAndNumber = /^[a-zA-Z0-9_.-]*$/;
const validMessageVariableRegExp = /\[.*\]/;
const IpRegExp =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

const minContactToOptimization = 99;
const minPausedMinOptimization = 10;
const maxPausedMinOptimization = 2400;
const minThreshold = 0;
const maxThreshold = 99;

export const validPhoneE164Format = /^\+[1-9]\d{1,14}$/;

export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const testSchema = {
  isRequired: (field) => {
    return function () {
      const { parent } = this;
      const value = get(parent, field);

      if (!isDefine(value)) {
        return false;
      }

      return true;
    };
  },
  mustBeIntegerNumber: (field) => {
    return function () {
      const { parent } = this;
      const value = get(parent, field);
      if (!isNumeric(value)) {
        return false;
      }

      if (!isInteger(Number(value))) {
        return false;
      }

      return true;
    };
  },
  mustGreaterThanZero: (field) => {
    return function () {
      const { parent } = this;
      const value = get(parent, field);
      if (!isNumeric(value)) {
        return false;
      }

      if (value <= 0) {
        return false;
      }

      return true;
    };
  },
};

const thresholdAutoOptimization = ({ isPercentage } = {}) => {
  if (isPercentage) {
    return Yup.number()
      .integer('This field must be integer number!')
      .min(minThreshold, 'This field must be in range 0 <= number < 100')
      .max(maxThreshold, 'This field must be in range 0 <= number < 100');
  }

  return Yup.number();
};

export const validateTrimAndRequiredString = (field, messageRequired) => {
  return Yup.string()
    .trim()
    .required(messageRequired || REQUIRED_FIELD(field));
};

export const validateCredentialsTracking = ({ subDomainRequired, accessKeyRequired } = {}) => {
  return Yup.object().shape({
    accessId: validateTrimAndRequiredString('Access ID'),
    accessKey: accessKeyRequired ? validateTrimAndRequiredString('Access Key') : Yup.string(),
    subDomain: subDomainRequired ? validateTrimAndRequiredString('Sub domain') : Yup.string(),
  });
};

export const validateAICreativeSetting = () => {
  return Yup.object().shape({
    category: validateTrimAndRequiredString('Category'),
    goal: validateTrimAndRequiredString('Goal'),
    target: validateTrimAndRequiredString('Target'),
    winningCreative: validateTrimAndRequiredString('Winning creative'),
    instructions: validateTrimAndRequiredString('Instructions'),
    knowledgeBaseFiles: Yup.mixed().test(
      'size',
      'There are some files larger than 2 Mb.',
      function () {
        const files = this.parent?.knowledgeBaseFiles || [];
        if (files.length > 0 && files.some((file) => bytesToMegaBytes(file.size) > 2)) {
          return false;
        }

        return true;
      }
    ),
  });
};

export const validateAutoOptimization = ({ validateByMessageType, allFieldRequired } = {}) => {
  const requiredForVoice = function (value) {
    const messageType = this.options?.context?.messageType;
    const isVoice = CampaignModel.isVoiceCampaign(messageType);

    if ((validateByMessageType && isVoice) || allFieldRequired) {
      if (!isNumeric(value)) {
        return false;
      }
    }

    return true;
  };

  const requiredForSMS = function (value) {
    const messageType = this.options?.context?.messageType;
    const isMessageText = !CampaignModel.isVoiceCampaign(messageType);

    if ((validateByMessageType && isMessageText) || allFieldRequired) {
      if (!isNumeric(value)) {
        return false;
      }
    }

    return true;
  };

  const required = function (value) {
    if (!isDefine(value)) {
      return false;
    }

    return true;
  };

  return Yup.object().shape({
    autoOp: Yup.boolean(),
    testSize: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['autoOp'], {
        is: (autoOp) => autoOp,
        then: Yup.number()
          .integer('Test size must be integer number!')
          // .required('Test size is required field!')
          .test('check_range', 'Range', function () {
            const { path } = this;
            const totalTarget = this?.options?.context?.totalTarget || 0;

            //* If totalTarget not in context -> it's not send campaign screen -> ignore
            if (!has(this?.options?.context, 'totalTarget')) {
              return true;
            }

            const { testSize } = this.parent;
            if (!!toString(testSize)) {
              if (testSize <= minContactToOptimization || testSize >= totalTarget) {
                return this.createError({
                  path,
                  message: `Test size must be in range ${minContactToOptimization} < number < ${totalTarget}`,
                });
              }
            }

            return true;
          })
          .test('required', REQUIRED_FIELD('This field'), required),
      }),
    pausedMin: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['autoOp'], {
        is: (autoOp) => autoOp,
        then: Yup.number()
          // .required('Paused time size is required field!')
          .integer('Paused time size must be integer number!')
          .min(
            minPausedMinOptimization,
            `Paused time must be in range ${
              minPausedMinOptimization - 1
            } < number < ${maxPausedMinOptimization}`
          )
          .max(
            maxPausedMinOptimization - 1,
            `Paused time must be in range ${
              minPausedMinOptimization - 1
            } < number < ${maxPausedMinOptimization}`
          )
          .test('required', REQUIRED_FIELD('This field'), required),
      }),

    threshold: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForSMS
      ),
    }),
    thresholdPerReply: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),
    thresholdPerBlock: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),
    thresholdPerOptout: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),
    thresholdPerConvertor: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForSMS
      ),
    }),
    thresholdRevenuePerMilMessage: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization().test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForSMS
      ),
    }),
    thresholdRevenuePerMilMinute: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization().test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForVoice
      ),
    }),
    thresholdRevenuePerDeliveredCall: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization().test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForVoice
      ),
    }),
    thresholdCallRate: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForVoice
      ),
    }),
    thresholdRoi: Yup.number().when(['autoOp'], {
      is: (autoOp) => autoOp,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),

    autoOpLap2: Yup.boolean(),
    // autoOpLap2CreativeSize: Yup.number()
    //   .transform(emptyStringToNull)
    //   .nullable()
    //   .when(['autoOp', 'autoOpLap2'], {
    //     is: (autoOp, autoOpLap2) => autoOp && autoOpLap2,
    //     then: Yup.number()
    //       .integer('Amount must be integer number!')
    //       .test('check_amount', 'message check amount creative size', function () {
    //         const { path } = this;
    //         const { creativeIds, messageType } = this?.options?.context || {};
    //         const { autoOpLap2CreativeSize = 0 } = this.parent;

    //         const numberOfCreative = (creativeIds || []).length;

    //         if (!has(this?.options?.context, 'creativeIds')) {
    //           return true;
    //         }

    //         if (CampaignModel.isVoiceCampaign(messageType)) {
    //           return true;
    //         }

    //         if (!isDefine(autoOpLap2CreativeSize)) {
    //           return this.createError({
    //             path,
    //             message: REQUIRED_FIELD('Amount'),
    //           });
    //         }

    //         if (!numberOfCreative) {
    //           return this.createError({
    //             path,
    //             message: `Select at least one creative`,
    //           });
    //         }

    //         if (autoOpLap2CreativeSize <= 0 || autoOpLap2CreativeSize > numberOfCreative) {
    //           return this.createError({
    //             path,
    //             message: `Amount must be in range 0 < number <= ${numberOfCreative} (amount of creatives selected)`,
    //           });
    //         }

    //         return true;
    //       }),
    //   }),
    testSizeLap2: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['autoOp', 'autoOpLap2'], {
        is: (autoOp, autoOpLap2) => autoOp && autoOpLap2,
        then: Yup.number()
          .integer('Test size lap 2 must be integer number!')
          // .required('Test size lap 2 is required field!')
          .test('check_range', 'Range', function () {
            const { path } = this;
            const totalTarget = this?.options?.context?.totalTarget || 0;
            const { testSizeLap2 } = this.parent;

            //* If totalTarget not in context -> it's not send campaign screen -> ignore
            if (!has(this?.options?.context, 'totalTarget')) {
              return true;
            }

            if (!!toString(testSizeLap2)) {
              if (testSizeLap2 <= minContactToOptimization || testSizeLap2 >= totalTarget) {
                return this.createError({
                  path,
                  message: `Test size lap 2 must be in range ${minContactToOptimization} < number < ${totalTarget} (total target)`,
                });
              }
            }

            return true;
          })
          .test('required', REQUIRED_FIELD('This field'), required),
      }),
    pausedMinLap2: Yup.number()
      .transform(emptyStringToNull)
      .nullable()
      .when(['autoOp', 'autoOpLap2'], {
        is: (autoOp, autoOpLap2) => autoOp && autoOpLap2,
        then: Yup.number()
          // .required('Paused time lap 2 size is required field!')
          .integer('Paused time lap 2 size must be integer number!')
          .min(10, 'Paused time lap 2 must be in range 9 < number < 2400')
          .max(2399, 'Paused time lap 2 must be in range 9 < number < 2400')
          .test('required', REQUIRED_FIELD('This field'), required),
      }),

    thresholdLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForSMS
      ),
    }),
    thresholdPerReplyLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),
    thresholdPerBlockLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),
    thresholdPerOptoutLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),
    thresholdPerConvertor2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForSMS
      ),
    }),

    thresholdRevenuePerMilMessageLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization().test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForSMS
      ),
    }),
    thresholdRevenuePerMilMinuteLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization().test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForVoice
      ),
    }),
    thresholdRevenuePerDeliveredCallLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization().test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForVoice
      ),
    }),
    thresholdCallRateLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        requiredForVoice
      ),
    }),
    thresholdRoiLap2: Yup.number().when(['autoOpLap2'], {
      is: (autoOpLap2) => autoOpLap2,
      then: thresholdAutoOptimization({ isPercentage: true }).test(
        'required',
        REQUIRED_FIELD('This field'),
        required
      ),
    }),
  });
};

export const validateSleepTimer = () => {
  return Yup.object().shape({
    chkSleepTimer: Yup.boolean(),
    startSleepTime: Yup.mixed().test(
      'check-sleep-weeks-days',
      'You must select at least start-end sleep timer or week days',
      function () {
        const { chkSleepTimer, startSleepTime, endSleepTime, weekDays } = this.parent;
        if (chkSleepTimer && !startSleepTime && !endSleepTime && weekDays.length <= 0) {
          return false;
        }

        return true;
      }
    ),
    endSleepTime: Yup.mixed().test(
      'check-sleep-weeks-days',
      'You must select at least start-end sleep timer or week days',
      function () {
        const { chkSleepTimer, startSleepTime, endSleepTime, weekDays } = this.parent;
        if (chkSleepTimer && !startSleepTime && !endSleepTime && weekDays.length <= 0) {
          return false;
        }

        return true;
      }
    ),
    weekDays: Yup.array().test(
      'check-sleep-weeks-days',
      'You must select at least start-end sleep timer or week days',
      function () {
        const { chkSleepTimer, startSleepTime, endSleepTime, weekDays } = this.parent;
        if (
          chkSleepTimer &&
          !isDefine(startSleepTime) &&
          !isDefine(endSleepTime) &&
          weekDays.length <= 0
        ) {
          return false;
        }

        if (isArray(weekDays) && weekDays.length === 7) {
          return this.createError({
            path: this.path,
            message: `You cannot select the whole week to sleep`,
          });
        }

        return true;
      }
    ),
  });
};

export const validateScrubSetting = () => {
  return Yup.object().shape({
    autoScrub: Yup.boolean(),
    autoScrubInterval: Yup.number().when({
      is: (autoScrub) => autoScrub,
      then: Yup.number()
        .required(REQUIRED_FIELD('Interval'))
        .min(0, MUST_BE_LARGER_OR_EQUAL_THAN('Interval', 0)),
    }),

    autoMoveBadDid: Yup.boolean(),
    badDidGroupId: Yup.mixed().when(['autoMoveBadDid'], {
      is: (autoMoveBadDid) => autoMoveBadDid,
      then: Yup.mixed().test(
        'required-bad-did-group',
        REQUIRED_FIELD('Target group'),
        testSchema.isRequired('badDidGroupId')
      ),
    }),
  });
};

export const validateTrimString = () => {
  return Yup.string().trim();
};

export const validateOptoutLink = () => {
  return Yup.object().shape({
    optoutLinkType: Yup.string(),
    optoutLink: Yup.array().when(['optoutLinkType'], {
      is: (optoutLinkType) => !OptOutModel.isNoOptoutLink(optoutLinkType),
      then: Yup.array().min(1, REQUIRED_FIELD('Optout Link')),
    }),
  });
};

//! Helper validate
// helper for yup transform function
const emptyStringToNull = (value, originalValue) => {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null;
  }
  return value;
};

export const validateIvrSetting = Yup.object().when(['ivrEnabled'], {
  is: (ivrEnabled) => ivrEnabled,
  then: Yup.object().shape({
    audioBuilderEnabled: Yup.boolean(),

    forwardPhone: validateTrimAndRequiredString('Forward phone'),

    ivrMediaId: Yup.mixed().when(['audioBuilderEnabled'], {
      is: (audioBuilderEnabled) => !audioBuilderEnabled,
      then: Yup.mixed().test('Available', REQUIRED_FIELD('IVR Audio'), function () {
        const {
          parent: { ivrMediaId },
        } = this;
        if (!ivrMediaId) {
          return false;
        }

        return true;
      }),
    }),
    audioBuilderSettings: Yup.object().when(['audioBuilderEnabled'], {
      is: (audioBuilderEnabled) => audioBuilderEnabled,
      then: Yup.object().shape({
        enableMediaGroup: Yup.boolean(),
        mediaGroupId: Yup.mixed().when(['enableMediaGroup'], {
          is: (enableMediaGroup) => enableMediaGroup,
          then: Yup.mixed().test('required', REQUIRED_FIELD('Media group'), function (value) {
            if (!isDefine(value)) {
              return false;
            }
            return true;
          }),
        }),
        mainAudioId: Yup.mixed().when(['enableMediaGroup'], {
          is: (enableMediaGroup) => !enableMediaGroup,
          then: Yup.mixed().test('required', REQUIRED_FIELD('Main audio'), function (value) {
            if (!isDefine(value)) {
              return false;
            }
            return true;
          }),
        }),
      }),
    }),
  }),
});

export const validateOuboundImmediateForwardPhone = Yup.string().when(
  ['viaOutboundImmediateForwardPhone', 'ivrEnabled'],
  {
    is: (viaOutboundImmediateForwardPhone, ivrEnabled) => {
      return (
        (isBoolean(viaOutboundImmediateForwardPhone) ? viaOutboundImmediateForwardPhone : true) &&
        !ivrEnabled
      );
    },
    then: validateTrimAndRequiredString('Forward phone number'),
  }
);

export const validateForwardPhoneInboundIVR = validateTrimAndRequiredString('Forward phone');

export const validateMediaInoundIVR = Yup.mixed().test(
  'Available',
  REQUIRED_FIELD('IVR Audio'),
  function () {
    const {
      parent: { ivrMediaId },
    } = this;
    if (!ivrMediaId) {
      return false;
    }

    return true;
  }
);

export const validateInboundIvrSetting = Yup.object().when(['ivrInboundEnabled'], {
  is: (ivrInboundEnabled) => ivrInboundEnabled,
  then: Yup.object().shape({
    forwardPhone: validateForwardPhoneInboundIVR,
    ivrMediaId: validateMediaInoundIVR,
  }),
});

const checkAllDelimiterAppearTogether = (listDelimiter, domains) => {
  let listDelimiterAppear = listDelimiter.reduce((arr, el) => {
    if (domains.includes(el)) {
      arr = [...arr, el];
    }
    return arr;
  }, []);

  return listDelimiterAppear.length > 1;
};

export const checkIsValidDomain = (val = '') => {
  if (isString(val) && validDomain.test(val?.trim() || '')) {
    return true;
  }
  return false;
};

export const checkIsValidIP = (ip) => {
  if (isString(ip) && IpRegExp.test(ip?.trim() || '')) {
    return true;
  }

  return false;
};

export const isOnlyNumber = (val = '') => {
  return onlyNumber.test(val);
};

//! Validate
const genStatFieldValidation = (nameFieldFrom, nameFieldTo) => {
  return {
    [nameFieldFrom]: Yup.string().test(
      'test-range',
      `${nameFieldFrom} must be smaller than ${nameFieldTo}`,
      function () {
        const { parent } = this;
        const valueFrom = parent[nameFieldFrom];
        const valueTo = parent[nameFieldTo];

        if (valueFrom && valueTo) {
          if (Number(valueFrom) > Number(valueTo)) {
            return false;
          }
        }

        return true;
      }
    ),
  };
};

export const validateFilterMonitoring = Yup.object().shape({
  ...genStatFieldValidation('sentFrom', 'sentTo'),
  ...genStatFieldValidation('deliveredFrom', 'deliveredTo'),
  ...genStatFieldValidation('clickedFrom', 'clickedTo'),
  ...genStatFieldValidation('repliedFrom', 'repliedTo'),
  ...genStatFieldValidation('convertorFrom', 'convertorTo'),
  ...genStatFieldValidation('optoutFrom', 'optoutTo'),
  ...genStatFieldValidation('failedFrom', 'failedTo'),
  ...genStatFieldValidation('blockedFrom', 'blockedTo'),
  ...genStatFieldValidation('attemptFailedFrom', 'attemptFailedTo'),
  ...genStatFieldValidation('revenueFrom', 'revenueTo'),
  ...genStatFieldValidation('revenuePerMilFrom', 'revenuePerMilTo'),
});

export const validateInvoke = Yup.object().shape({
  ipAddress: Yup.string()
    .trim(REQUIRED_FIELD('IP Address'))
    .required(REQUIRED_FIELD('IP Address'))
    .matches(IpRegExp, INCORRECT_FORMAT('IP Address')),
});

export const dateRangesYup = Yup.object().shape({
  from: Yup.mixed().test('date-required', REQUIRED_FIELD('From'), function () {
    const { from, to } = this.parent;
    if (!from && !!to) {
      return false;
    }

    return true;
  }),
  // to: Yup.date()
  //   .when(['from'], {
  //     is: (from) => !!from,
  //     then: Yup.date().required(REQUIRED_FIELD('To')),
  //   })
  //   .nullable(),
});

export const validateDateRanges = Yup.object().shape({
  // dateRanges: dateRangesYup,
});

export const validateUseCase = Yup.object().shape({
  usecaseId: Yup.string(),
  usecaseName: Yup.string().required(REQUIRED_FIELD('Use case name')),
  usecaseType: Yup.string().required(REQUIRED_FIELD('Use case type')),
  vertical: Yup.string().required(REQUIRED_FIELD('Vertical')),

  customerCareEmail: validateTrimAndRequiredString('Customer care email'),
  customerCarePhone: validateTrimAndRequiredString('Customer care phone'),
  termsAndConditionsUrl: validateTrimAndRequiredString('Terms and conditions URL'),

  description: Yup.string()
    .min(40, STRING_LENGTH_MIN('Description', 40))
    .max(4096, STRING_LENGTH_MAX('Description', 4096))
    .trim()
    .required(REQUIRED_FIELD('Description')),
  initSIDs: Yup.string().when(['usecaseId'], {
    is: (usecaseId) => {
      const isCreateUsecase = !usecaseId;
      return isCreateUsecase;
    },
    then: Yup.string().trim().required(REQUIRED_FIELD('Sender ID(s)')),
  }),
  sample1: Yup.string()
    .min(20, STRING_LENGTH_MIN('Sample 1 message', 20))
    .max(1024, STRING_LENGTH_MAX('Sample 1 message', 1024))
    .trim()
    .required(REQUIRED_FIELD('Sample 1 message')),
  sample2: Yup.string()
    .min(20, STRING_LENGTH_MIN('Sample 2 message', 20))
    .max(1024, STRING_LENGTH_MAX('Sample 2 message', 1024))
    .trim()
    .required(REQUIRED_FIELD('Sample 2 message')),

  messageFlow: Yup.string()
    .min(40, STRING_LENGTH_MIN('Message flow', 40))
    .max(2048, STRING_LENGTH_MAX('Message flow', 2048))
    .required(REQUIRED_FIELD('Message flow')),

  optinKeywords: Yup.string().max(320, STRING_LENGTH_MAX('Optin keywords', 320)),
  optinMessage: Yup.string()
    .min(20, STRING_LENGTH_MIN('Optin message', 20))
    .max(320, STRING_LENGTH_MAX('Optin message', 320))
    .required(REQUIRED_FIELD('Optin message')),

  optoutKeywords: Yup.string().max(320, STRING_LENGTH_MAX('Optout keywords', 320)),
  optoutMessage: Yup.string()
    .min(20, STRING_LENGTH_MIN('Optout message', 20))
    .max(320, STRING_LENGTH_MAX('Optout message', 320))
    .required(REQUIRED_FIELD('Optout message')),

  helpKeywords: Yup.string().max(320, STRING_LENGTH_MAX('Help keywords', 320)),
  helpMessage: Yup.string()
    .min(20, STRING_LENGTH_MIN('Help message', 20))
    .max(320, STRING_LENGTH_MAX('Help message', 320))
    .required(REQUIRED_FIELD('Help message')),
});

export const validateBrand = Yup.object().shape({
  firstName: Yup.string().required(REQUIRED_FIELD('First name')),
  lastName: Yup.string().required(REQUIRED_FIELD('Last name')),
  brandName: Yup.string().required(REQUIRED_FIELD('Brand name')),
  city: Yup.string().required(REQUIRED_FIELD('City')),
  companyName: Yup.string().required(REQUIRED_FIELD('Company name')),
  website: Yup.string().required(REQUIRED_FIELD('Company website')),
  country: Yup.string().required(REQUIRED_FIELD('Country')),
  entityType: Yup.string().required(REQUIRED_FIELD('Entity type')),
  vertical: Yup.string().required(REQUIRED_FIELD('Vertical')),
  customerType: Yup.string().required(REQUIRED_FIELD('Customer type')),
  brandType: Yup.string().required(REQUIRED_FIELD('Brand type')),
  einIssuingCountry: Yup.string().required(REQUIRED_FIELD('EIN Issuing Country')),
  // einIssuingCountryFreetext: Yup.string().when(['einIssuingCountry'], {
  //   is: (einIssuingCountry) => einIssuingCountry === 'Other',
  //   then: Yup.string().required(REQUIRED_FIELD('Other EIN Issuing country')),
  // }),
  businessType: Yup.string().required(REQUIRED_FIELD('Business type')),
  businessRegistrationIdType: Yup.string().required(
    REQUIRED_FIELD('Business registration Id Type')
  ),
  businessRegistrationIdTypeOtherFreetext: Yup.string().when(['businessRegistrationIdType'], {
    is: (businessRegistrationIdType) => businessRegistrationIdType === 'Other',
    then: Yup.string().required(REQUIRED_FIELD('Other business registration Id Type')),
  }),

  phone: Yup.string()
    .matches(isPhoneNumber, 'Phone number is must start with +')
    .required(REQUIRED_FIELD('Phone number')),
  street: Yup.string().required(REQUIRED_FIELD('Address')),
  state: Yup.string().required(REQUIRED_FIELD('State')),
  postalCode: Yup.string().required(REQUIRED_FIELD('ZIP')),
  email: Yup.string().email(INCORRECT_FORMAT('Email')).required(REQUIRED_FIELD('Email')),
  seniority: Yup.string().required(REQUIRED_FIELD('Seniority')),
  ein: Yup.string()
    // .matches(onlyNumber, IS_NUMBER_TYPE('Tax number / ID / EIN'))
    .required(REQUIRED_FIELD('Tax number / ID / EIN')),
});

const emailYupCheck = Yup.string()
  .test('EmailValidateCustom', 'Email is invalid', function () {
    const { email } = this.parent;
    if (email && email.trim()) {
      if (validEmail.test(email.trim())) {
        return true;
      }
    }
    return false;
  })
  .required('Email is required');

const passwordYupCheck = Yup.string()
  .trim('Password is required')
  .required('Password is required')
  .min(8, 'Password is invalid')
  .max(30, 'Password is invalid');

export const validationLogin = Yup.object().shape({
  email: emailYupCheck,
  password: passwordYupCheck,
});

export const validationLoginWithOTP = Yup.object().shape({
  email: emailYupCheck,
  password: passwordYupCheck,
  otp: Yup.string().trim('OTP is required').required('OTP is required').length(6, 'OTP is invalid'),
});

export const validationForgotPassword = Yup.object().shape({
  email: emailYupCheck,
});

export const validationResetPassword = Yup.object().shape({
  password: passwordYupCheck,
  passwordConfirm: passwordYupCheck,
});

export const validationChangePassword = Yup.object().shape({
  currentPassword: validateTrimString('Password')
    .min(8, 'Password is invalid!')
    .max(30, 'Password is invalid!'),
  newPassword: Yup.string().when(['currentPassword'], {
    is: (currentPassword) => !!currentPassword,
    then: validateTrimString('New password')
      .min(8, 'New Password is invalid!')
      .max(30, 'New Password is invalid!'),
  }),
  newPasswordConfirm: Yup.string().when(['currentPassword'], {
    is: (currentPassword) => !!currentPassword,
    then: validateTrimString('New password confirm')
      .min(8, 'New password confirm is invalid!')
      .max(30, 'New password confirm is invalid!'),
  }),
});

export const validationLeadCallback = Yup.object().shape({
  leadCallback: Yup.string()
    .trim('Link is required field!')
    .required('IP is required field!')
    .matches(validDomainRequireHttpHttps, 'Link is incorrect format!')
    .required('Link is required field!'),
});

export const validationLeadFilter = Yup.object().shape({
  leadFilter: Yup.array().of(
    Yup.object().shape({
      tag: Yup.string().required('Tag is required field!'),
      operator: Yup.string().required('Operator is required field!'),
      value: Yup.string().required('Value is required field!'),
    })
  ),
});

export const validationPremiumOrderSchema = Yup.object().shape({
  volume: Yup.number()
    .typeError('Volume must be number type!')
    .min(1000, 'Volume must be in range [1,000 - 10,000,000]')
    .max(10000000, 'Volume must be in range [1,000 - 10,000,000]')
    .integer('Volume must be integer number!')
    .required('Volume is required field!'),
  duration: Yup.number()
    .typeError('Duration must be number type!')
    .min(1, 'Number of day must be in range [1 - 365]')
    .max(365, 'Number of day must be in range [1 - 365]')
    .required('Duration is required field!'),
});

//* For text mode
export const validationListKeyValue = Yup.array().of(
  Yup.object().shape({
    key: Yup.string().required(REQUIRED_FIELD('Key')),
    value: Yup.string()
      .required(REQUIRED_FIELD('Value'))

      .test('checkValue', 'Value is required field!', function () {
        const value = this?.parent?.value;
        if (!value) {
          return false;
        }

        return true;
      })
      .test('check IP', INCORRECT_FORMAT('Value'), function () {
        const { key, value } = this.parent;

        //* Validate if Key = IP
        if (key === 'ip') {
          const ips = value?.split(',').map((el) => el.trim());
          let errorFound = false;

          for (let ip of ips) {
            if (!(checkIsValidIP(ip) || cidrRegex({ exact: true }).test(ip))) {
              errorFound = true;
              break;
            }
          }

          if (errorFound) {
            return this.createError({
              path: this.path,
              message: INCORRECT_FORMAT('Value'),
            });
          }
        }

        //* Validate if value is accept only Number
        if (key === 'ipMaxClick') {
          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }

        if (key === 'expireTime') {
          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }

        if (key === 'shortLinkMaxClick') {
          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }

        if (key === 'MaxRiskScore' || key === 'maxRiskScore') {
          if (isNumeric(value) && Number(value) < 0) {
            return this.createError({
              path: this.path,
              message: MUST_BE_LARGER_OR_EQUAL_THAN('Value', 0),
            });
          }

          if (isNumeric(value) && !Number.isInteger(Number(value))) {
            return this.createError({
              path: this.path,
              message: MUST_BE_INTEGER_NUMBER('Value'),
            });
          }

          if (!isOnlyNumber(value)) {
            return this.createError({
              path: this.path,
              message: MUST_BE_NUMBER('Value'),
            });
          }
        }

        return true;
      }),
  })
);

export const validationClickRequestSchema = Yup.object().shape({
  previewUrl: Yup.string().nullable().matches(validDomain, 'Custom page is incorrect format!'),
  safeUrl: Yup.string().nullable().matches(validDomain, 'Custom page is incorrect format!'),

  clickFilterSetting: Yup.object().shape({
    enableRedirectPreviewPage: Yup.bool(),
    enableRedirectSafePage: Yup.bool(),

    //* Preview
    redirectPreviewPageCondition: Yup.array().when(['enableRedirectPreviewPage'], {
      is: (condition) => !!condition,
      then: validationListKeyValue,
    }),
    previewPageWhitelistCondition: Yup.array().when(['enableRedirectPreviewPage'], {
      is: (condition) => !!condition,
      then: validationListKeyValue,
    }),

    //* Unwanted
    redirectSafePageCondition: Yup.array().when(['enableRedirectSafePage'], {
      is: (condition) => !!condition,
      then: validationListKeyValue,
    }),
    originalPageWhitelistCondition: Yup.array().when(['enableRedirectSafePage'], {
      is: (condition) => !!condition,
      then: validationListKeyValue,
    }),
  }),
});

export const validationIP = Yup.object().shape({
  ip: validateTrimAndRequiredString('IP').matches(IpRegExp, 'IP is incorrect format!'),
});

export const validationUserAgent = Yup.object().shape({
  userAgent: validateTrimAndRequiredString('User agent'),
});

export const validationUserAgentSkipPreview = Yup.object().shape({
  userAgentSkipPreview: validateTrimAndRequiredString('User agent'),
});

export const validationCreateTicket = Yup.object().shape({
  title: validateTrimAndRequiredString('Title'),
});

export const validationFormCreative = Yup.object().shape({
  title: validateTrimAndRequiredString('Title'),
  message: validateTrimAndRequiredString('Message').max(
    9000,
    'Message is too long, need to less than 9000 characters!'
  ),
  // routeId: Yup.mixed().required(REQUIRED_FIELD('Route')),
  countries: Yup.mixed().test('checkCountry', REQUIRED_FIELD('Countries'), function (countries) {
    const { routeId } = this.parent;

    if (
      isDefine(routeId) &&
      RouteModel.isRouteNeedCreativeApprovalRequired(routeId) &&
      countries.length <= 0
    ) {
      return false;
    }

    return true;
  }),
});

export const validationChangeNameMenu = Yup.object().shape({
  title: Yup.string().trim('Title is required field!').required('Title is required field!'),
});

export const validationInboxSend = Yup.object().shape({
  message: validateTrimAndRequiredString('Message'),
  // .test('checkTotalSMS', 'Length of message must be in 1 SMS!', function() {
  //   const { parent } = this;
  //   const { message } = parent;
  //   if (message && typeof message === 'string' && smsCounter(message.trim()).smsCount > 1) {
  //     return false;
  //   }

  //   return true;
  // }),
});

export const validationAllowSend = Yup.object().shape({
  campaignCheck: Yup.boolean(),
  deliveredThreshold: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold must be integer number!')
    .min(0, 'Threshold must be in range 0 <= number <= 99')
    .max(99, 'Threshold must be in range 0 <= number <= 99')
    .required('Threshold is required field!'),
});

export const validationEditDomainUsageThreshold = Yup.object().shape({
  domainRotation: Yup.boolean(),
  domainUsageThreshold: Yup.number()
    .typeError('Domain usage threshold must be integer number!')
    .integer('Domain usage threshold must be integer number!')
    .min(0, 'Domain usage threshold must be in range 0 <= number <= 99')
    .required('Domain usage threshold is required field!'),
});
export const validationAllowRelease = Yup.object().shape({
  autoRenew: Yup.boolean(),
  deliveredThresholdRenew: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold must be integer number!')
    .min(0, 'Threshold must be in range 0 <= number <= 99')
    .max(99, 'Threshold must be in range 0 <= number <= 99')
    .required('Threshold is required field!'),
});

export const validationCallForward = Yup.object().shape({
  phone: Yup.string()
    .typeError('Must be a phone number')
    .matches(phoneRegExp, 'Must be a phone number')
    .required(REQUIRED_FIELD('Phone number')),
  workingWeekDays: Yup.array().min(1, REQUIRED_FIELD('Working day')),
  workingHourFrom: Yup.string().required(REQUIRED_FIELD('Working hour from')),
  workingHourTo: Yup.string()
    .required(REQUIRED_FIELD('Working hour to'))
    .test('check-from-to', 'Working hour from cannot after working hour to', function () {
      const { parent } = this;
      const { workingHourFrom, workingHourTo } = parent;
      if (isDefine(workingHourFrom) && isDefine(workingHourTo)) {
        if (Number(workingHourTo) < Number(workingHourFrom)) {
          return false;
        }
      }
      return true;
    }),
});

export const validationReleaseDidByClickRate = Yup.object().shape({
  rate: Yup.number()
    .typeError('Rate must be integer number!')
    .integer('Rate release must be integer number!')
    .min(0, 'Rate must be in range 0 <= number <= 100')
    .max(100, 'Rate release must be in range 0 <= number <= 100')
    .required('Rate release is required field!'),
});

export const validationReleaseDid = Yup.object().shape({
  autoRelease: Yup.boolean(),
  deliveredThresholdRelease: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold release must be integer number!')
    .min(0, 'Threshold release must be in range 0 <= number <= 99')
    .max(99, 'Threshold release must be in range 0 <= number <= 99')
    .required('Threshold release is required field!'),
});

export const validationTransferDomain = Yup.object().shape({
  targetGroupId: Yup.object().shape({
    value: Yup.string().required('Target group id is required field'),
  }),
  domainDeliveredThresholdTransfer: Yup.number()
    .typeError('Threshold must be integer number!')
    .integer('Threshold release must be integer number!')
    .min(0, 'Threshold release must be in range 0 <= number <= 99')
    .max(99, 'Threshold release must be in range 0 <= number <= 99')
    .required('Threshold release is required field!'),
});

const checkOfferPPC = (isPPC, logic) => {
  if (isPPC) {
    return {
      is: (ppc) => !!ppc,
      then: logic,
    };
  }

  return {
    is: (ppc) => !ppc,
    then: logic,
  };
};

export const validateOffer = Yup.object().shape(
  {
    ppc: Yup.boolean(),
    title: validateTrimAndRequiredString('Title').max(
      200,
      'Title is too long, need to less than 200 characters!'
    ),
    domain: Yup.string().when(
      ['ppc'],
      checkOfferPPC(false, Yup.string().required('Domain is required field!').nullable())
    ),
    safeUrl: Yup.string().when(
      ['ppc'],
      checkOfferPPC(
        false,
        Yup.string().matches(validDomain, 'Safe url is incorrect format!').nullable()
      )
    ),
    previewUrl: Yup.string().when(
      ['ppc'],
      checkOfferPPC(
        false,
        Yup.string().matches(validDomain, 'Preview url is incorrect format!').nullable()
      )
    ),
    // expireTime: Yup.number().when(
    //   ['ppc'],
    //   checkOfferPPC(
    //     false,
    //     Yup.number()
    //       .min(1, 'Expire time must be greater than 0!')
    //       .when(['expireTimeUnit'], {
    //         is: (expireTimeUnit) => !!expireTimeUnit,
    //         then: Yup.number()
    //           .typeError(NUMBER_FIELD('Expire time'))
    //           .required(NUMBER_FIELD('Expire time'))
    //           .integer('Expire time must be integer number!'),
    //         otherwise: Yup.number().nullable(),
    //       })
    //   )
    // ),
    // expireTimeUnit: Yup.string().when(
    //   ['ppc'],
    //   checkOfferPPC(
    //     false,
    //     Yup.string().when(['expireTime'], {
    //       is: (expireTime) => isNumber(expireTime),
    //       then: Yup.string()
    //         .typeError(MUST_SELECTED_FIELD('Expire time unit'))
    //         .required(REQUIRED_FIELD('Expire time unit')),
    //       otherwise: Yup.string().nullable(),
    //     })
    //   )
    // ),

    shortlinkTagSetting: Yup.object().shape({
      enabled: Yup.boolean(),
    }),

    clickFilterSetting: Yup.object().when(
      ['ppc'],
      checkOfferPPC(
        false,
        Yup.object().shape({
          enableRedirectPreviewPage: Yup.bool(),
          enableRedirectSafePage: Yup.bool(),

          //* Preview
          redirectPreviewPageCondition: Yup.array().when(['enableRedirectPreviewPage'], {
            is: (condition) => !!condition,
            then: validationListKeyValue,
          }),
          previewPageWhitelistCondition: Yup.array().when(['enableRedirectPreviewPage'], {
            is: (condition) => !!condition,
            then: validationListKeyValue,
          }),

          //* Unwanted
          redirectSafePageCondition: Yup.array().when(['enableRedirectSafePage'], {
            is: (condition) => !!condition,
            then: validationListKeyValue,
          }),
          originalPageWhitelistCondition: Yup.array().when(['enableRedirectSafePage'], {
            is: (condition) => !!condition,
            then: validationListKeyValue,
          }),
        })
      )
    ),

    payPerCall: Yup.object().when(
      ['ppc'],
      checkOfferPPC(
        true,
        Yup.object().shape({
          targetNumber: validateTrimAndRequiredString('Target number'),
          backupTargetNumber: validateTrimAndRequiredString('Backup target number'),
          didGroupId: Yup.object().when(['trackingTargetNumber'], {
            is: (trackingTargetNumber) => trackingTargetNumber,
            then: Yup.object().shape({
              id: Yup.number().test('required-custom', REQUIRED_FIELD('DID Group'), function () {
                const { parent } = this;
                const { id } = parent;

                if (!isDefine(id)) {
                  return this.createError({
                    path: 'payPerCall.didGroupId',
                    message: REQUIRED_FIELD('DID Group'),
                  });
                }

                return true;
              }),
            }),
          }),
          convertOn: Yup.number()
            .typeError(IS_NUMBER_TYPE('Convert on'))
            .integer(MUST_BE_INTEGER_NUMBER('Convert on'))
            .min(1, MUST_BE_LARGER_THAN('Convert on', 0))
            .required(REQUIRED_FIELD('Convert on')),

          conversionValue: Yup.number()
            .typeError(IS_NUMBER_TYPE('Conversion value'))
            .min(0, MUST_BE_LARGER_THAN('Conversion value', 0)),

          timeout: Yup.number()
            .typeError(IS_NUMBER_TYPE('Timeout'))
            .integer(MUST_BE_INTEGER_NUMBER('Timeout'))
            .min(0, MUST_BE_LARGER_THAN('Timeout', 0)),

          workingWeekDays: Yup.array().when(['hoursOfOperationCheck'], {
            is: (hoursOfOperationCheck) => hoursOfOperationCheck,
            then: Yup.array().min(1, REQUIRED_FIELD('Working week days')),
          }),

          workingHourFrom: Yup.string()
            .nullable()
            .when(['hoursOfOperationCheck'], {
              is: (hoursOfOperationCheck) => hoursOfOperationCheck,
              then: Yup.string()
                .required(REQUIRED_FIELD('Working hour FROM'))
                .nullable()
                .test('check-working-hour', 'FROM must be less than TO', function () {
                  const { parent } = this;
                  const { hoursOfOperationCheck, workingHourFrom, workingHourTo } = parent;

                  if (!!hoursOfOperationCheck && Number(workingHourFrom) > Number(workingHourTo)) {
                    return false;
                  }

                  return true;
                }),
            }),
          workingHourTo: Yup.string()
            .nullable()
            .when(['hoursOfOperationCheck'], {
              is: (hoursOfOperationCheck) => hoursOfOperationCheck,
              then: Yup.string().required(REQUIRED_FIELD('Working hour TO')).nullable(),
            }),

          globalCap: Yup.number()
            .typeError(IS_NUMBER_TYPE('Global cap'))
            .integer(MUST_BE_INTEGER_NUMBER('Global cap'))
            .min(0, MUST_BE_LARGER_THAN('Global cap', 0)),

          monthlyCap: Yup.number()
            .typeError(IS_NUMBER_TYPE('Monthly cap'))
            .integer(MUST_BE_INTEGER_NUMBER('Monthly cap'))
            .min(0, MUST_BE_LARGER_THAN('Monthly cap', 0)),

          dailyCap: Yup.number()
            .typeError(IS_NUMBER_TYPE('Daily cap'))
            .integer(MUST_BE_INTEGER_NUMBER('Daily cap'))
            .min(0, MUST_BE_LARGER_THAN('Daily cap', 0)),

          hourlyCap: Yup.number()
            .typeError(IS_NUMBER_TYPE('Hourly cap'))
            .integer(MUST_BE_INTEGER_NUMBER('Hourly cap'))
            .min(0, MUST_BE_LARGER_THAN('Hourly cap', 0)),

          inboundIvrSetting: Yup.object().when(['ivrInboundEnabled'], {
            is: (ivrInboundEnabled) => ivrInboundEnabled,
            then: Yup.object().shape({
              ivrMediaId: validateMediaInoundIVR,
            }),
          }),
        })
      )
    ),
  },
  ['expireTime', 'expireTimeUnit']
);

export const validationCreateContact = Yup.object().shape({
  groupName: Yup.string()
    .required(REQUIRED_FIELD('Group name'))
    .min(3, 'Please input 3 ~ 200 characters')
    .max(200, 'Please input 3 ~ 200 characters'),
  country: Yup.string().required(REQUIRED_FIELD('Country')),
});

export const validateRenameContact = Yup.object().shape({
  title: Yup.string()
    .required('Title is required field!')
    .trim('Title is required field!')
    .min(3, 'Please input 3 ~ 200 characters')
    .max(200, 'Please input 3 ~ 200 characters'),
});

export const validateMoveDidSelected = Yup.object().shape({
  targetGroupId: Yup.object().shape({
    value: Yup.number()
      .typeError('Target Group Id is incorrect format number!')
      .required('Target Group Id is required field!'),
  }),
});

export const validateSchemaMoveDomain = Yup.object().shape({
  targetGroupId: Yup.object().shape({
    value: Yup.string().required(REQUIRED_FIELD('Target group ID')),
  }),
});

export const validateSchemaReport = Yup.object().shape({
  title: Yup.string().required('Title is required field!').trim('Title is required field!'),
  description: Yup.string()
    .required('Description is required field!')
    .trim('Title is required field!'),
});

export const validateSchemaMigrateDomainGroup = Yup.object().shape({
  groupId: Yup.object().shape({
    value: Yup.string().required('Source group must be selected!'),
  }),
  targetGroupId: Yup.object().shape({
    value: Yup.string().required('Source group must be selected!'),
  }),
  amount: Yup.number()
    .integer('Amount must be integer number!')
    .min(1, 'Amount must be greater or equal than 1!')
    .when(['groupId', 'targetGroupId'], {
      is: (groupId, targetGroupId) => !!groupId && !!targetGroupId,
      then: Yup.number().required('Amount is required field!'),
    }),
});

export const validateCreateDomainGroup = Yup.object().shape({
  name: Yup.string()
    .test('Trim', 'Name field is required', function () {
      const { name } = this.parent;
      if (name && name.trim()) {
        return true;
      }
      return false;
    })
    .required('Name field is required!')
    .max(200, 'Name is too long, need to less than 200 characters!'),
});

export const validationCommonName = Yup.object().shape({
  name: Yup.string()
    .test('Trim', 'Name field is required', function () {
      const { name } = this.parent;
      if (name && name.trim()) {
        return true;
      }
      return false;
    })
    .required('Name field is required!')
    .max(200, 'Name is too long, need to less than 200 characters!'),
  countries: Yup.string().required(REQUIRED_FIELD('Country')),
  routeId: Yup.string().required(REQUIRED_FIELD('Route')),
});

export const validationCommonTitle = Yup.object().shape({
  title: Yup.string()
    .test('Trim', 'Title field is required', function () {
      const { title } = this.parent;
      if (title && title.trim()) {
        return true;
      }
      return false;
    })
    .required('Title must required!')
    .max(200, 'Title is too long, need to less than 200 characters!'),
});

export const validateCreateResponder = ({ isTemplate } = {}) =>
  Yup.object().shape({
    enableTemplate: Yup.boolean(),
    // selected: Yup.string().required('Contact group must be selected!'),
    title: validateTrimAndRequiredString('Responder name'),
    selectedTemplate: Yup.string().when('enableTemplate', {
      is: (el) => el,
      then: Yup.string().required('Responder template must be selected!'),
    }),

    didGroups: isTemplate
      ? Yup.mixed()
      : Yup.mixed().test(
          'check-required',
          'Select at least DID group or Contact group!',
          function (didGroups) {
            const { contactGroups } = this.parent;

            if (contactGroups?.length <= 0 && didGroups?.length <= 0) {
              return false;
            }

            return true;
          }
        ),

    contactGroups: isTemplate
      ? Yup.mixed()
      : Yup.mixed().test(
          'check-required',
          'Select at least DID group or Contact group!',
          function (contactGroups) {
            const { didGroups } = this.parent;

            if (contactGroups?.length <= 0 && didGroups?.length <= 0) {
              return false;
            }

            return true;
          }
        ),
  });

export const validationSchemaCampaignEdit = (variables) =>
  Yup.object().shape({
    scheduling: Yup.string().nullable(),
    schedulingStopTime: Yup.string()
      .test('CheckDateAfter', 'Stop time must be after Start time', function () {
        const { parent } = this;
        const { scheduling, schedulingStopTime } = parent;

        if (scheduling && schedulingStopTime) {
          return momentInstance(schedulingStopTime).isAfter(momentInstance(scheduling));
        }

        return true;
      })
      .nullable(),
    bccSize: Yup.number().when(['bccOn', 'messageType'], {
      is: (bccOn, messageType) => bccOn && messageType === messageTypeEnum.mms,
      then: Yup.number()
        .required('Bcc size is required field!')
        .integer('Bcc size must be integer number!')
        .min(2, 'Bcc size must be in range 2 <= number <= 10')
        .max(10, 'Bcc size must be in range 2 <= number <= 10'),
    }),
    responderOffers: Yup.array().of(
      Yup.object().shape({
        typeInput: Yup.string(),
        variable: Yup.string()
          .required('Variable is required field!')
          .matches(
            validMessageVariableRegExp,
            'Message variable is incorrect format! It must have square brackets. E.g: [custom-var]'
          )
          .test(
            'check-variable',
            'Message variable is duplicated with existing variable list of system!',
            function () {
              const { originalValue } = this.options;
              if (originalValue) {
                const variable = originalValue.toLowerCase();
                // check if value existed in variables
                if (variables.map((ele) => ele.toLowerCase()).some((ele) => ele === variable)) {
                  return false;
                }
              }
              return true;
            }
          ),
        offerId: Yup.string().when('typeInput', {
          is: (val) => val !== 'inputText',
          then: Yup.string().required('Offer must be selected!'),
        }),
        url: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string()
            .required('Url is required field!')
            .matches(validDomain, 'URL is incorrect format!'),
        }),
        domain: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string().required('Domain is required field!'),
        }),
      })
    ),

    numberOfAttachmentInMessage: Yup.number().when(['messageType'], {
      is: (messageType) => CampaignModel.isMessageTypeSupportAttachment(messageType),
      then: Yup.number()
        .integer(MUST_BE_INTEGER_NUMBER('Number attachment'))
        .test('number-attachment', MUST_BE_LARGER_THAN('Number attachment'), function () {
          const { parent } = this;
          const { media, numberOfAttachmentInMessage } = parent;
          if (isArray(media) && media?.length > 0 && numberOfAttachmentInMessage < 1) {
            return false;
          }

          return true;
        }),
    }),
  });

export const validationSchemaCampaign = (variables) =>
  Yup.object().shape({
    autoOp: Yup.boolean(),
    totalTarget: Yup.number().nullable(),
    messageType: Yup.string(),
    agent: Yup.boolean(),
    // fromPhone: Yup.string().required('Type phone is required!'),
    // phone: Yup.string().required('Contact group is required!'),
    country: Yup.string().required(REQUIRED_FIELD('Country')),
    contactGroups: Yup.array().min(1, REQUIRED_FIELD('Contact group(s)')),
    impressionUrl: Yup.string().matches(validDomain, 'URL is incorrect format!'),
    bccSize: Yup.number().when(['bccOn', 'messageType'], {
      is: (bccOn, messageType) => bccOn && messageType === messageTypeEnum.mms,
      then: Yup.number()
        .typeError('Bcc size must be integer number!')
        .required('Bcc size is required field!')
        .integer('Bcc size must be integer number!')
        .min(2, 'Bcc size must be in range 2 <= number <= 10')
        .max(10, 'Bcc size must be in range 2 <= number <= 10'),
    }),

    //! Fix scheduling
    scheduling: Yup.string().when('activeScheduling', {
      is: (activeScheduling) => !!activeScheduling,
      then: Yup.string()
        .nullable()
        .test(
          'required',
          'Scheduling Start Time / Scheduling Stop Time must be chosen',
          function (startScheduling) {
            const { schedulingStopTime } = this.parent;

            if (!startScheduling && !schedulingStopTime) {
              return false;
            }

            return true;
          }
        ),
    }),
    schedulingStopTime: Yup.string().when('activeScheduling', {
      is: (activeScheduling) => !!activeScheduling,
      then: Yup.string()
        .nullable()
        // .required(REQUIRED_FIELD('Scheduling Stop time'))
        .test(
          'required',
          'Scheduling Start Time / Scheduling Stop Time must be chosen',
          function (schedulingStopTime) {
            const { scheduling } = this.parent;

            if (!scheduling && !schedulingStopTime) {
              return false;
            }

            return true;
          }
        )
        .test('CheckDateAfter', 'Stop time must be after Start time', function () {
          const { parent } = this;
          const { scheduling, schedulingStopTime } = parent;

          if (scheduling && schedulingStopTime) {
            return momentInstance(schedulingStopTime).isAfter(momentInstance(scheduling));
          }

          return true;
        }),
    }),

    //! ANI
    // ani: Yup.string().when('sendMethod', {
    //   is: (sendMethod) => sendMethod === sendMethodEnum.oneWay,
    //   then: Yup.string().required(REQUIRED_FIELD('ANI')),
    // }),

    //! Select routes
    routesTwoWays: Yup.array().when('sendMethod', {
      is: (sendMethod) => sendMethod === sendMethodEnum.twoWays,
      then: Yup.array().of(
        Yup.object().shape({
          routeId: Yup.string().required(REQUIRED_FIELD('Route')),
          didGroupIds: Yup.array().min(1, REQUIRED_FIELD('DIDs Group')),
        })
      ),
    }),

    //! Anis
    routesOneWay: Yup.array().when('sendMethod', {
      is: (sendMethod) => CampaignModel.isOneWaySendMethod(sendMethod),
      then: Yup.array().min(1, REQUIRED_FIELD('Routes')),
    }),
    anis: Yup.array().when(['sendMethod'], {
      is: (sendMethod) => CampaignModel.isOneWaySendMethod(sendMethod),
      then: Yup.array().of(
        Yup.object().shape({
          ani: validateTrimAndRequiredString('ANI'),
        })
      ),
    }),

    //! Audio builder
    mediaWithConfigs: Yup.object().when(['messageType', 'agent'], {
      is: (messageType, agent) => CampaignModel.isVoiceCampaign(messageType) && !agent,
      then: validateMediaWithConfigs({ isSelectMultiMedia: true }),
    }),

    //! Vertical
    vertical: Yup.string().when(['sendMethod', 'routesTwoWays', 'routesOneWay'], {
      is: (sendMethod, routesTwoWays, routesOneWay) =>
        CampaignModel.checkNon10DLCFound(
          sendMethod === sendMethodEnum.oneWay ? routesOneWay : routesTwoWays
        ),
      then: Yup.string().required(REQUIRED_FIELD('Vertical field')),
    }),

    creativeIds: Yup.array()
      .when(['creativeOnFly', 'messageType', 'agent'], {
        is: (creativeOnFly, messageType, agent) => {
          if (
            !CampaignModel.isVoiceCampaign(messageType) ||
            (CampaignModel.isVoiceCampaign(messageType) && agent)
          ) {
            return true;
          }
          // if (creativeOnFly && creativeOnFly.length <= 0) {
          //   return true;
          // }

          return false;
        },
        then: Yup.array()
          .test('not-null', 'Select at least one creative!', function () {
            const { parent } = this;
            if (!isDefine(parent.creativeIds)) {
              return false;
            }

            return true;
          })
          .min(1, 'Select at least one creative!'),
      })
      .nullable(),
    creativeOnFly: Yup.array().of(
      Yup.object().shape({
        message: Yup.string().required('Message is required field!'),
      })
    ),

    //! Optout Link
    optoutLink: Yup.object().when(['sendMethod', 'messageType'], {
      is: (sendMethod, messageType) => {
        const isSMS = CampaignModel.isSMS(messageType);
        const isMMS = CampaignModel.isMMS(messageType);
        const isMMSE = CampaignModel.isMMSE(messageType);

        return CampaignModel.isOneWaySendMethod(sendMethod) && (isSMS || isMMS || isMMSE);
      },
      then: validateOptoutLink(),
    }),

    //! Offers
    offerIds: Yup.array().when(['messageType'], {
      is: (messageType) => !CampaignModel.isVoiceCampaign(messageType),
      then: Yup.array().when(['offerOption', 'offerOnFly'], {
        is: (offerOption, offerOnFly) =>
          offerOption === stateOffer.OFFER && isArray(offerOnFly) && offerOnFly.length <= 0,
        then: Yup.array()
          .nullable()
          .required('Select at least one offer!')
          .min(1, 'Select at least one offer!'),
      }),
    }),
    offerOnFly: Yup.array().when(['messageType'], {
      is: (messageType) => !CampaignModel.isVoiceCampaign(messageType),
      then: Yup.array().when('offerOption', {
        is: (val) => val === stateOffer.OFFER,
        then: Yup.array().of(
          Yup.object().shape({
            url: Yup.string()
              .required('Url is required field!')
              .matches(validDomain, 'URL is incorrect format!'),
            domain: Yup.string().required('Domain is required field!'),
          })
        ),
      }),
    }),
    domain: Yup.string().when(['offerOption', 'urlShortened'], {
      is: (offerOption, urlShortened) => urlShortened && offerOption === stateOffer.PREFILL_OFFER,
      then: Yup.string().required('Select at least one domain!'),
    }),
    dtmfTimeout: Yup.number().integer(MUST_BE_INTEGER_NUMBER('DTMF Timeout')),
    campaignOffset: Yup.number().typeError('Campaign offset must be number type!'),
    numberOfAttachmentInMessage: Yup.number().when(['messageType', 'ivrEnabled'], {
      is: (messageType, ivrEnabled) =>
        CampaignModel.isMessageTypeSupportAttachment(messageType) && !ivrEnabled,
      then: Yup.number()
        .integer(MUST_BE_INTEGER_NUMBER('Number attachment'))
        .test('number-attachment', MUST_BE_LARGER_THAN('Number attachment'), function () {
          const { parent, path } = this;
          const { media, numberOfAttachmentInMessage } = parent;
          if (isArray(media) && media?.length > 0) {
            if (!numberOfAttachmentInMessage || numberOfAttachmentInMessage < 1) {
              return this.createError({
                path,
                message: `${MUST_BE_LARGER_THAN('Number attachment', 0)}`,
              });
            }

            if (numberOfAttachmentInMessage > media.length) {
              return this.createError({
                path,
                message: `${MUST_BE_LESS_OR_EQUAL_THAN('Number attachment', media.length)}`,
              });
            }
          }

          return true;
        }),
    }),

    responderOnFly: Yup.object().when(['modeResponder'], {
      is: (modeResponder) => modeResponder === ModesResponderEnum.onfly,
      then: Yup.object().shape({
        inboundForwardNumber: validateTrimAndRequiredString('Inbound forward number'),
        outboundForwardNumber: validateTrimAndRequiredString('Outbound forward number'),
      }),
    }),

    autoStopThreshold: Yup.number()
      .moreThan(0, MUST_BE_LARGER_THAN('Auto stop threshold', 0))
      .integer(MUST_BE_INTEGER_NUMBER('Auto stop threshold'))
      .nullable(),

    responderAdvanceSetting: Yup.array().of(
      Yup.object().shape({
        typeInput: Yup.string(),
        variable: Yup.string()
          .required('Variable is required field!')
          .matches(
            validMessageVariableRegExp,
            'Message variable is incorrect format! It must have square brackets. E.g: [custom-var]'
          )
          .test(
            'check-variable',
            'Message variable is duplicated with existing variable list of system!',
            function () {
              const { originalValue } = this.options;
              if (originalValue) {
                const variable = originalValue.toLowerCase();
                // check if value existed in variables
                if (variables.map((ele) => ele.toLowerCase()).some((ele) => ele === variable)) {
                  return false;
                }
              }
              return true;
            }
          ),
        offerId: Yup.string().when('typeInput', {
          is: (val) => val !== 'inputText',
          then: Yup.string().required('Offer must be selected!'),
        }),
        url: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string()
            .required('Url is required field!')
            .matches(validDomain, 'URL is incorrect format!'),
        }),
        domain: Yup.string().when('typeInput', {
          is: (val) => val === 'inputText',
          then: Yup.string().required('Domain is required field!'),
        }),
      })
    ),

    autoOptimization: Yup.object().when(['totalTarget'], {
      is: (totalTarget) => totalTarget > minContactToOptimization,
      then: validateAutoOptimization({ validateByMessageType: true }),
    }),

    evaluatedElements: Yup.array().when(['totalTarget'], {
      is: (totalTarget) => totalTarget > minContactToOptimization,
      then: Yup.array().test(
        'required',
        REQUIRED_FIELD('Evaluated elements'),
        function (evaluatedElements) {
          const { autoOptimization } = this.parent;
          if (autoOptimization?.autoOp === true) {
            if (!isArray(evaluatedElements) || evaluatedElements.length <= 0) {
              return false;
            }
          }

          return true;
        }
      ),
    }),
  });

const validationResponderDetail = Yup.object().shape({
  ani: Yup.string().when('sendMethod', {
    is: (sendMethod) => sendMethod === sendMethodEnum.oneWay,
    then: Yup.string().required(REQUIRED_FIELD('ANI input')),
  }),

  messageType: Yup.string().required(REQUIRED_FIELD('Message type')),
  media: Yup.array().when(['messageType'], {
    is: (messageType) => ResponderModel.isVoice(messageType),
    then: Yup.array()
      // .of(
      //   Yup.object().shape({
      //     delayedTime: Yup.string().test(
      //       'number',
      //       MUST_BE_NUMBER('Delayed time'),
      //       testSchema.mustGreaterThanZero('delayedTime')
      //     ),
      //   })
      // )
      .test('isRequired', REQUIRED_FIELD('Media'), function () {
        const { parent } = this;

        if (isEmpty(parent?.media) || parent?.media.length <= 0) {
          return false;
        }

        return true;
      }),
  }),

  creativeOnFly: Yup.array().of(
    Yup.object().shape({
      message: Yup.string().required('Message is required field!'),
      offerOption: Yup.string(),

      offerOnFly: Yup.array().of(
        Yup.object().shape({
          domain: Yup.string().required('Domain is required field'),
          url: Yup.string()
            .required('Url is required field')
            .matches(validDomain, 'URL is incorrect format!'),
        })
      ),

      offers: Yup.array().when('offerOption', {
        is: (val) => val === stateOffer.OFFER,
        then: Yup.array().min(1, 'Select at least 1 offer!'),
      }),

      domain: Yup.string()
        .when(['offerOption', 'urlShortened'], {
          is: (offerOption, urlShortened) => {
            return offerOption === stateOffer.PREFILL_OFFER && urlShortened;
          },
          then: Yup.string().required('Select at least 1 domain!'),
        })
        .nullable(),
      // delayedTime: Yup.number()
      //   .integer('Delayed time must be integer number!')
      //   .min(0, 'Delayed time must be greater or equal than 0!')
      //   .required('Delayed time is required field!'),
    })
  ),

  creativeIds: Yup.array().when(['creativeOnFly', 'messageType'], {
    is: (val, messageType) => val && val.length <= 0 && !ResponderModel.isVoice(messageType),
    then: Yup.array()
      .of(
        Yup.object().shape({
          delayedTime: Yup.number()
            .typeError('Delayed time must be integer number!')
            // .integer('Delayed time must be integer number!')
            .min(0, 'Delayed time must be greater or equal than 0!')
            .test('limitDecimal', 'Limit 3 decimals', function () {
              const { parent } = this;
              const { delayedTime = 0 } = parent;
              return checkLimitDecimal(delayedTime, 3);
            })
            .nullable(),
          offerOption: Yup.string(),

          offerOnFly: Yup.array().of(
            Yup.object().shape({
              domain: Yup.string().required('Domain is required field'),
              url: Yup.string()
                .required('Url is required field')
                .matches(validDomain, 'URL is incorrect format!'),
            })
          ),

          offers: Yup.array().when('offerOption', {
            is: (val) => val === stateOffer.OFFER,
            then: Yup.array().min(1, 'Select at least 1 offer!'),
          }),

          domain: Yup.string()
            .when(['offerOption', 'urlShortened'], {
              is: (offerOption, urlShortened) => {
                return offerOption === stateOffer.PREFILL_OFFER && urlShortened;
              },
              then: Yup.string().required('Select at least 1 domain!'),
            })
            .nullable(),
        })
      )
      .required('Creatives must not be empty!'),
  }),
  impressionUrl: Yup.string().matches(validDomain, 'URL is incorrect format!').trim(),
});

export const validationNotificationSettingSchema = Yup.object().shape({
  notiEmailAddress: Yup.string()
    .test('EmailValidateCustom', 'Some email(s) is incorrect format!', function () {
      const { notiEmailAddress } = this.parent;
      if (notiEmailAddress && notiEmailAddress.trim()) {
        const listEmail = notiEmailAddress.split(',').map((el) => el.trim());
        if (listEmail.some((email) => !validEmail.test(email))) {
          return false;
        }
      }

      return true;
    })
    .required(REQUIRED_FIELD('Email(s)')),
});

const validationProfile = Yup.object().shape({
  myAccountFirstname: Yup.string()
    .test('DetectTrim', 'First name is required field!', function () {
      const { myAccountFirstname } = this.parent;
      if (myAccountFirstname && myAccountFirstname.trim()) {
        return true;
      }
      return false;
    })
    .required('First name is required field!'),

  myAccountLastname: Yup.string()
    .test('DetectTrim', 'Last name is required field!', function () {
      const { myAccountLastname } = this.parent;
      if (myAccountLastname && myAccountLastname.trim()) {
        return true;
      }
      return false;
    })
    .required('Last name is required field!'),

  myBillingName: Yup.string().required(REQUIRED_FIELD('Billing Name')),
  myBillingAddress: Yup.string().required(REQUIRED_FIELD('Billing Address')),
  myBillingCountry: Yup.string().required(REQUIRED_FIELD('Billing Country')),
  myBillingRegNo: Yup.string().required(REQUIRED_FIELD('Billing Reg No.')),
  myBillingVatNo: Yup.string().required(REQUIRED_FIELD('Billing VAT No.')),

  myBillingIBAN: validateTrimAndRequiredString('IBAN'),
  myBillingBIC: validateTrimAndRequiredString('BIC / SWIFT CODE'),
  myBillingIntermediaryBIC: validateTrimAndRequiredString('Intermediary BIC'),
  myBillingBank: validateTrimAndRequiredString('Bank'),
  myBillingBankAddress: validateTrimAndRequiredString('Bank Address'),
  myEntityName: validateTrimAndRequiredString('Entity Name'),
});

const validationSettingsSchema = Yup.object().shape({
  chkSleepTimer: Yup.boolean(),
  sleepWeekDays: Yup.array().test(
    'check-sleep-weeks-days',
    'You must select at least start-end sleep timer or week days',
    function () {
      const { chkSleepTimer, startSleepTime, endSleepTime, sleepWeekDays } = this.parent;
      if (
        chkSleepTimer &&
        !isDefine(startSleepTime) &&
        !isDefine(endSleepTime) &&
        sleepWeekDays.length <= 0
      ) {
        return false;
      }

      if (isArray(sleepWeekDays) && sleepWeekDays.length === 7) {
        return this.createError({
          path: this.path,
          message: `You cannot select the whole week to sleep`,
        });
      }

      return true;
    }
  ),
  startSleepTime: Yup.mixed().test(
    'check-sleep-weeks-days',
    'You must select at least start-end sleep timer or week days',
    function () {
      const { chkSleepTimer, startSleepTime, endSleepTime, sleepWeekDays } = this.parent;
      if (chkSleepTimer && !startSleepTime && !endSleepTime && sleepWeekDays.length <= 0) {
        return false;
      }

      return true;
    }
  ),
  endSleepTime: Yup.mixed().test(
    'check-sleep-weeks-days',
    'You must select at least start-end sleep timer or week days',
    function () {
      const { chkSleepTimer, startSleepTime, endSleepTime, sleepWeekDays } = this.parent;
      if (chkSleepTimer && !startSleepTime && !endSleepTime && sleepWeekDays.length <= 0) {
        return false;
      }

      return true;
    }
  ),

  inputDomain: Yup.string().when('prefillOfferEnable', {
    is: (val) => val,
    then: Yup.string()
      .matches(validDomain, 'URL is incorrect format!')
      .required('Input domain is required field!'),
  }),

  params: Yup.array().when('prefillOfferEnable', {
    is: (val) => val,
    then: Yup.array()
      .of(
        Yup.object().shape({
          param: Yup.string()
            .matches(onlyLettersAndNumber, 'Invalid param!')
            .required('Param must be filled!'),
          value: Yup.string().required('Value param must be filled'),
        })
      )
      .required('You need add at least one param!'),
  }),

  paramsFullfill: Yup.array().when('fullfillOfferEnable', {
    is: (val) => val,
    then: Yup.array()
      .of(
        Yup.object().shape({
          param: Yup.string()
            .matches(onlyLettersAndNumber, 'Invalid param!')
            .required('Param must be filled!'),
          value: Yup.string().required('Value param must be filled'),
        })
      )
      .required('You need add at least one param!'),
  }),

  paramsFullfillImpression: Yup.array().of(
    Yup.object().shape({
      param: Yup.string()
        .matches(onlyLettersAndNumber, 'Invalid param!')
        .required('Param must be filled!'),
      value: Yup.string().required('Value param must be filled'),
    })
  ),

  autoOptimization: validateAutoOptimization({ allFieldRequired: true }),

  seedNumber: Yup.string().test(
    'max 10 numbers',
    'You can only input maximum 10 seed numbers',
    function () {
      const { seedNumber } = this.parent;
      if (isString(seedNumber)) {
        if (
          seedNumber
            .split(',')
            .map((el) => el.trim())
            .filter((el) => !!el).length > 10
        ) {
          return false;
        }
      }

      return true;
    }
  ),
});

const validationUsersSchema = Yup.object().shape({
  email: emailYupCheck,
  firstname: Yup.string()
    .test('DetectTrim', 'First name is required field!', function () {
      const { firstname } = this.parent;
      if (firstname && firstname.trim()) {
        return true;
      }
      return false;
    })
    .required('First name is required field!'),
  lastname: Yup.string()
    .test('DetectTrim', 'Last name is required field!', function () {
      const { lastname } = this.parent;
      if (lastname && lastname.trim()) {
        return true;
      }
      return false;
    })
    .required('Last name is required field!'),
  phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  agentAcc: Yup.string().test(
    'EmailValidateCustom',
    "Agent's email is incorrect format!",
    function () {
      const { agentAcc } = this.parent;
      if (agentAcc && agentAcc.trim()) {
        if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(agentAcc.trim())) {
          return false;
        }
      }
      return true;
    }
  ),
  country: Yup.string().required('Country is required field!'),
  statusName: Yup.string().required('Status is required field!'),
  timeName: Yup.string().required('Time Zone is required field!'),
  phoneType: Yup.string().required('Phone Type is required field!'),
  limitNumberMessagePerDay: Yup.number().when('twoWay', {
    is: (value) => value === '2' || value === 2,
    then: Yup.number()
      .typeError('Limit number message per day must be integer number!')
      .integer('Limit number message per day must be integer number!')
      .required('Limit number is required field and in range [100 - 15,000]!')
      .min(100, 'Limit number must be in range [100 - 15,000]!')
      .max(15000, 'Limit number must be in range [100 - 15,000]!'),
  }),
});

const validationDateTimeExportDetail = Yup.object().shape({
  fromDate: Yup.date()
    .test('compareDate', 'From Date must be earlier than To Date!', function () {
      const { fromDate, toDate } = this.parent;
      return fromDate && toDate && moment(fromDate) <= moment(toDate);
    })
    .required('From Date is required field!'),
  toDate: Yup.date().required('To Date is required field!'),
});

const validationDateTimeCampaign = Yup.object().shape({
  lastSentDate: Yup.date().required('Last sent date is required field!'),
});

const validationPayment = Yup.object().shape({
  numberRecharge: Yup.number().test(
    'check-invalid-number',
    'Input has the minimum is 500 and the maximum 10000',
    function () {
      const { numberRecharge, autoRecharge } = this.parent;
      if (autoRecharge) {
        if (
          isDefine(numberRecharge) &&
          (Number(numberRecharge) < 500 || Number(numberRecharge) > 10000)
        ) {
          return false;
        }
      }
      return true;
    }
  ),
});
const validationPaymentCreate = Yup.object().shape({
  email: Yup.string().trim().email(INCORRECT_FORMAT('Email')).required(REQUIRED_FIELD('Email')),

  phone: validateTrimAndRequiredString('Phone'),

  name: Yup.string()
    .test('check-trim', 'Name is required field!', function () {
      const { name } = this.parent;
      if (name) {
        if (name.trim() === '') return false;
      }
      return true;
    })
    .required('Name is required field!'),

  postal_code: Yup.string()
    .test('check-trim', 'Zip code is required field!', function () {
      const { postal_code } = this.parent;
      if (postal_code) {
        if (postal_code.trim() === '') return false;
      }
      return true;
    })
    .required('Zip code is required field!'),
});

const validationSplitGroup = Yup.object().shape({
  size: Yup.number()
    .moreThan(0, 'Size must be greater than 0')
    .typeError('Size must be integer number!')
    .integer('Size must be integer number!')
    .required(REQUIRED_FIELD('Size')),
});

const validationAddDomain = Yup.object().shape({
  domains: Yup.array().of(
    Yup.string()
      .matches(validDomain, 'Incorrect domain format!')
      .test('check-duplicate-domain', 'Check Domain', function () {
        const { path, parent } = this;
        if (parent) {
          // Check require field
          const listDomains = trimListString([...parent]);
          if (
            !this.options.originalValue ||
            (typeof this.options.originalValue === 'string' &&
              this.options.originalValue.trim() === '')
          ) {
            return this.createError({
              path,
              message: 'The domain input is required field!',
            });
          }

          // Check duplicate
          if (hasDuplicateItem(listDomains)) {
            const listItemDuplicate = filterDuplicateItem(listDomains);
            if (listItemDuplicate.includes(this.options.originalValue.trim())) {
              return this.createError({
                path,
                message: 'Duplicate domain - please check again!',
              });
            }
          }

          // Check delimeter in list domain
          if (listDomains) {
            for (let i = 0; i < listDelimiter.length; i++) {
              const valueTrimAndRemoveSpace = this.options.originalValue.trim().replace(/ /g, '');
              if (valueTrimAndRemoveSpace.includes(listDelimiter[i])) {
                if (valueTrimAndRemoveSpace.split(listDelimiter[i]).length > 1) {
                  return this.createError({
                    path,
                    message: 'Incorrect domain format!',
                  });
                }
              }
            }
          }

          // Check Vietnamese
          if (
            /[\u0300-\u036fđĐ]/.test(
              this.options.originalValue.trim().replace(/ /g, '').normalize('NFD')
            )
          ) {
            return this.createError({
              path,
              message: 'Incorrect domain format!',
            });
          }
        }
        return true;
      })
      .required('The domain input is required field!')
  ),
});

const validationAddBulkDomain = Yup.object().shape({
  domains: Yup.string()
    .test('check-valid-domain', 'List of domain is incorrect format!', function () {
      const { domains } = this.parent;
      // Check if all delimiter appear together
      if (checkAllDelimiterAppearTogether(listDelimiter, domains)) {
        return false;
      }
      return true;
    })
    .test('check-domain-add-bulk', 'Some domain in list is incorrect format!', function () {
      const { domains } = this.parent;
      if (domains && typeof domains === 'string') {
        const checkValidDomainWithDelimeter = (delimeter) => {
          const listDomainsAfterConvert = domains.split(delimeter);
          let isValidDomain = true;
          listDomainsAfterConvert
            .filter((el) => el)
            .forEach((domain) => {
              if (!validDomain.test(domain.trim())) {
                isValidDomain = false;
              } else if (
                /[\u0300-\u036fđĐ]/.test(domain.trim().replace(/ /g, '').normalize('NFD'))
              ) {
                isValidDomain = false;
              }
            });

          return isValidDomain;
        };

        let isPass = true;
        // Check it with each delimiter
        listDelimiter.forEach((d) => {
          if (checkValidDomainWithDelimeter(d) === false) {
            isPass = false;
          }
        });

        return isPass;
      }
    })
    .required('The domain input is required field!'),
});

const validationSearchDomain = Yup.object().shape({
  price_from: Yup.number()
    .typeError('Price from must be a number')
    .test('check-larger-than-price-to', 'Price From must be smaller than Price To!', function () {
      const { price_from, price_to } = this.parent;
      if (price_from && price_to) {
        if (!Number.isNaN(Number(price_from))) {
          if (!Number.isNaN(Number(price_to))) {
            if (Number(price_from) > Number(price_to)) return false;
          }
        }
      }
      return true;
    })
    .required('Price from is required field!'),
  price_to: Yup.number()
    .typeError('Price to must be a number')
    .required('Price to is required field!'),
  quantity: Yup.number()
    .typeError('Quantity must be a number')
    .test(
      'check-quantity',
      `Quantity must be in range [1 - ${MAX_DOMAIN_ALLOW_PURCHASE}]`,
      function () {
        const { quantity } = this.parent;
        if (quantity) {
          if (!Number.isNaN(Number(quantity))) {
            if (quantity < 1 || quantity > MAX_DOMAIN_ALLOW_PURCHASE) return false;
          }
        }
        return true;
      }
    )
    .required('Quantity is required field!'),
});

const validationAddDidUserDetailSchema = Yup.object().shape({
  phone: Yup.string()
    .required('Phone is required field!')
    .test('check-valid-phone', 'List of phone number is incorrect format!', function () {
      const { phone } = this.parent;
      // Check if all delimiter appear together
      if (phone) {
        if (checkAllDelimiterAppearTogether(listDelimiter, phone)) {
          return false;
        }
        return true;
      }
      return true;
    })
    .test('check-valid', 'Phone in list is incorrect format!', function () {
      const { phone } = this.parent;
      if (phone && typeof phone === 'string') {
        let isPass = false;
        listDelimiter.forEach((delimiter) => {
          if (phone.includes(delimiter)) {
            const checkValidPhoneWithDelimeter = (delimiter) => {
              const listPhoneAfterConvert = phone.split(delimiter);
              let isValidPhone = true;
              listPhoneAfterConvert
                .filter((el) => el)
                .forEach((p) => {
                  if (!phoneRegExp.test(p.trim())) {
                    isValidPhone = false;
                  }
                });
              return isValidPhone;
            };
            isPass = checkValidPhoneWithDelimeter(delimiter);
          }
        });
        return isPass;
      }
      return true;
    }),
});

const validateGetMessageStats = Yup.object().shape({
  dateRanges: dateRangesYup,
});

const validateVoluumSettingSchema = ({ isTheFirstCreate } = {}) => {
  const fields = {
    voluumMessageId: Yup.string().when(['voluumOption'], {
      is: (voluumOption) => voluumOption === VolummType.MessageID,
      then: Yup.string().required(REQUIRED_FIELD('Message ID')),
    }),
    voluumMappingPhone: Yup.string().when(['voluumOption'], {
      is: (voluumOption) => voluumOption === VolummType.PhoneMapping,
      then: Yup.string().required(REQUIRED_FIELD('Phone mapping')),
    }),
  };

  if (isTheFirstCreate) {
    fields.voluumAccessId = Yup.string().required(REQUIRED_FIELD('Access ID'));
    fields.voluumAccessKey = Yup.string().required(REQUIRED_FIELD('Access Key'));
  }

  return Yup.object().shape(fields);
};

export const validateMediaWithConfigs = ({ isSelectMultiMedia } = {}) =>
  Yup.object().shape({
    useConfigAudio: Yup.boolean(),
    enableMediaGroup: Yup.boolean(),
    mediaGroupId: Yup.mixed().when(['useConfigAudio', 'enableMediaGroup'], {
      is: (useConfigAudio, enableMediaGroup) => useConfigAudio && enableMediaGroup,
      then: Yup.mixed().test('required', REQUIRED_FIELD('Media group'), function (mediaGroup) {
        if (!mediaGroup) {
          return false;
        }

        return true;
      }),
    }),
    mainAudioId: Yup.mixed().when(['useConfigAudio', 'enableMediaGroup'], {
      is: (useConfigAudio, enableMediaGroup) => useConfigAudio && !enableMediaGroup,
      then: Yup.mixed().test('required', REQUIRED_FIELD('Main audio'), function (mainAudio) {
        if (!mainAudio) {
          return false;
        }

        return true;
      }),
    }),
    media: Yup.mixed().when(['useConfigAudio'], {
      is: (useConfigAudio, isAIAgent) => !useConfigAudio,
      then: isSelectMultiMedia
        ? Yup.mixed().test('required', REQUIRED_FIELD('Media'), function (media) {
            if (!media || (isArray(media) && media.length <= 0)) {
              return false;
            }

            return true;
          })
        : Yup.mixed().test('required', REQUIRED_FIELD('Media'), function (media) {
            if (!media) {
              return false;
            }

            return true;
          }),
    }),
  });

export const validateConditionsOptimizationSchema = () =>
  Yup.array().of(
    Yup.object().shape({
      value: validateTrimAndRequiredString('Value').test('number', 'msg-number', function (value) {
        if (value) {
          if (!isNumeric(value)) {
            return this.createError({
              path: this.path,
              message: 'Value must be a number',
            });
          }

          if (Number(value) < 0) {
            return this.createError({
              path: this.path,
              message: 'Value must be greater or equal to 0',
            });
          }
        }

        return true;
      }),
      condition: validateTrimAndRequiredString('Condition'),
      operator: validateTrimAndRequiredString('Operator'),
    })
  );

export const validateAutoReleaseSettingSchema = () =>
  Yup.object().shape({
    enabled: Yup.boolean(),
    // limit: Yup.number().when(['enabled'], {
    //   is: (enabled) => enabled,
    //   then: Yup.number()
    //     .typeError('Limit must be a number')
    //     .integer('Limit must be an integer number')
    //     .min(0, 'Limit must be equal or greater than 0'),
    // }),
    filters: Yup.array().when(['enabled'], {
      is: (enabled) => enabled,
      then: validateConditionsOptimizationSchema(),
    }),
  });

export const validateOptimizationSettingSchema = () =>
  Yup.object().shape({
    enabled: Yup.boolean(),
    filters: Yup.array().when(['enabled'], {
      is: (enabled) => enabled,
      then: validateConditionsOptimizationSchema(),
    }),

    enableSentPerCycle: Yup.boolean(),
    sentPerCycle: Yup.number().when(['enableSentPerCycle'], {
      is: (enableSentPerCycle) => enableSentPerCycle,
      then: Yup.number()
        .min(0, MUST_BE_LARGER_OR_EQUAL_THAN('Sent Per Cycle', 0))
        .integer(MUST_BE_INTEGER_NUMBER('Sent Per Cycle'))
        .required(REQUIRED_FIELD('Sent Per Cycle')),
    }),
    concurrentCheck: Yup.boolean(),
    rotation: Yup.boolean(),
    maxConcurrent: Yup.number().when(['enableSentPerCycle'], {
      is: (enableSentPerCycle) => enableSentPerCycle,
      then: Yup.number()
        .min(0, MUST_BE_LARGER_OR_EQUAL_THAN('Max concurrent use', 0))
        .integer(MUST_BE_INTEGER_NUMBER('Max concurrent use')),
    }),
  });

export const validateSleepTimerSchema = () =>
  Yup.object().shape({
    chkSleepTimer: Yup.boolean(),
    startSleepTime: Yup.string(),
    endSleepTime: Yup.string(),
    weekDays: Yup.array().of(Yup.string()),
  });

export {
  validationResponderDetail,
  validateGetMessageStats,
  validationAddDidUserDetailSchema,
  validationAddBulkDomain,
  validationSearchDomain,
  validationSplitGroup,
  validationPaymentCreate,
  validationPayment,
  validationSettingsSchema,
  validationUsersSchema,
  maxLengthName,
  validationDateTimeExportDetail,
  validationDateTimeCampaign,
  validationAddDomain,
  validateVoluumSettingSchema,
  validationProfile,
};
